

import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    appDrawer: {
      type: Boolean,
      default: true
    },
    default_currency: {
      type: String,
      default: ""
    }

  },
  watch: {
    appDrawer: function (newVal, oldVal) {
    }
  },
  data: () => ({
    gradient: null,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return Number(tooltipItem.yLabel)  +' '+ window.b2b_default_currency;
          }
        }
      },
      title: {
        display: false,
        position: 'top',
        text: '',
        fontStyle: 'bold',
        padding: 15,
        align: 'start'
      },
      legend: {
        display: false
      },

      scales: {
        xAxes: [
        
          {
            id: 'xAxis1',
            type: "category",
            ticks: {
              callback: function (label) {
                var year = label.split("-")[0];
                var month = label.split("-")[1];
                return month;
              }
            },
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            },
          },
          {
            id: 'xAxis2',
            type: "category",
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            },
            ticks: {
              callback: function (label) {
                var year = label.split("-")[0];
                var month = label.split("-")[1];
                if (month === "06") {
                  return year;
                } else {
                  return "";
                }
              }
            }
          }],
        yAxes: [{
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          ticks: {
            beginAtZero: true,
            min: 0,
            callback: function (value, index, values) {
              return value > 1000 ? value / 1000 + "k" : value;
            }
          }
        }]
      }

    }
  }),

  mounted() {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    this.gradient.addColorStop(0, 'rgba(189, 242, 216)')
    this.gradient.addColorStop(0.5, 'rgba(235, 245, 240)');
    this.gradient.addColorStop(1, 'rgba(255, 255, 255,0)');
    if (this.chartdata && this.chartdata.datasets && this.chartdata.datasets.length > 0) {
      this.chartdata.datasets[0].backgroundColor = this.gradient;
    }
    this.renderChart(this.chartdata, this.options)
  },


}